export default __webpack_public_path__ + "static/media/main-banner.1e9205d2.jpg";